import { Injectable } from "@angular/core";
import { db, JobSignature } from "../../../core/database/db";

@Injectable({ providedIn: "root" })
export class JobSignatureService {

  async bulkAddSignatures(signatures: JobSignature[]): Promise<void> {
    await db.jobSignature.bulkAdd(signatures);
  }

  async getSignaturesByJobId(jobId: number): Promise<JobSignature[]> {
    return db.jobSignature.where("jobId").equals(jobId)
      .toArray();
  }
}